import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { UnitsState } from './units.state';

@NgModule({
  imports: [
    NgxsModule.forFeature([UnitsState]),
  ],
})
export class UnitsStateModule {}
